import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const FinanceReportRoutes = defineRoute({
    record: {
        route: {
            path: "/finance-report",
            component: () => loadView(import("./FinanceReportTable.vue")),
        },
    },
});
